<template>
  <AppNav
    class="report-view-selector m-0"
    :class="{ invisible: !meTeamVisible }"
  >
    <li :class="{ active: !isTeam }">
      <a
        href="#"
        @click.prevent="onClick('my')"
      >
        Me
      </a>
    </li>
    <li :class="{ active: isTeam }">
      <a
        href="#"
        @click.prevent="onClick('team')"
      >
        All
      </a>
    </li>
  </AppNav>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'ReportViewSelector',
  computed: {
    ...mapState({
      meTeamVisible: ({ me_team_visible }) => me_team_visible,
    }),
    ...mapGetters(['isTeam']),
  },
  methods: {
    onClick(view) {
      this.$emit('change', view);
    },
  },
};
</script>
